import { cn } from "@newxsystems/shared";
import type { ITootTechPanelProps, TootTechPanelVariant } from "./TootTechPanel.props";

const variantClassName: Record<TootTechPanelVariant, string> = {
  feature: "border-orange-400/35",
  map: "border-red-400/30",
  media: "border-toot-grid-strong/70",
  proof: "border-orange-500/45",
};

export const TootTechPanel = ({
  children,
  className,
  eyebrow,
  footer,
  showDividers = true,
  title,
  variant = "feature",
}: ITootTechPanelProps) => {
  return (
    <section
      className={cn(
        "relative overflow-hidden bg-[var(--toot-color-surface)] text-[var(--toot-color-foreground)]",
        variantClassName[variant],
        className,
      )}
    >
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:28px_28px] opacity-40" />
      <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full border border-orange-400/25" />
      <div className="relative">
        {eyebrow ? (
          <div className="mb-3 text-xs font-semibold uppercase tracking-[0.24em] text-toot-orange">
            {eyebrow}
          </div>
        ) : null}
        {title ? (
          <div className="mb-4 text-xl font-semibold tracking-[-0.03em] text-toot-foreground md:text-2xl">
            {title}
          </div>
        ) : null}
        {showDividers ? (
          <div className="mb-5 h-px bg-gradient-to-r from-red-500/70 via-orange-400/45 to-transparent" />
        ) : null}
        {children ? <div className="text-sm leading-6 text-toot-muted">{children}</div> : null}
      </div>
      {footer ? (
        <div className="relative border-t border-toot-grid/90 px-5 py-4 text-xs text-toot-muted md:px-6">
          {footer}
        </div>
      ) : null}
    </section>
  );
};

TootTechPanel.displayName = "Surface::TootTechPanel";
